import { render, staticRenderFns } from "./ReinitPassword.vue?vue&type=template&id=6e87c539&scoped=true"
import script from "./ReinitPassword.vue?vue&type=script&lang=js"
export * from "./ReinitPassword.vue?vue&type=script&lang=js"
import style0 from "./ReinitPassword.vue?vue&type=style&index=0&id=6e87c539&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87c539",
  null
  
)

export default component.exports